import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class ThirdPartyAPI {
  
  static list = (id, success, failure) => {
    fetch(Config.app.link + 'api/third-party/list/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static cloud = (success, failure) => {
    fetch(Config.app.link + 'api/third-party/cloud-call', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/third-party/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (dist, success, failure) => {
    fetch(Config.app.link + 'api/third-party/add-edit', new Header('POST', dist))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/third-party/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  
  static logs = (body, success, failure) => {
    fetch(Config.app.link + 'api/third-party/logs', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default ThirdPartyAPI;